import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_3: FaireProductEntity = {
  token: "catalog_prod_prod-3",
  type: "product",
  name: "Reversible Pillow - Celebrate Everyday",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=400&fit=crop",
  priceDollars: 91.1,
  msrpDollars: 227.75,
  sku: "CO0003",
  caseSize: 1,
  material: "Glass",
  collectionToken: "col_confetti-cake",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 10,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_garden-outdoor"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
